import { useApolloClient } from '@apollo/client';
import { getAppointmentCartUid, getAppointmentCartUidMap } from 'Common/functions/AppointmentCart';
import getAppointmentCartByUid, { GetAppointmentCartByUid } from 'Common/functions/getAppointmentCartByUid';
import { useEffect, useState } from 'react';

const useAppointmentCartCookie = (serviceProviderId: string): [
    GetAppointmentCartByUid | undefined,
    boolean,
  ] => {
  const appointmentCartUidMap = getAppointmentCartUidMap();
  const appointmentCartUid = getAppointmentCartUid(appointmentCartUidMap, serviceProviderId);
  const [isLoading, setIsLoading] = useState(true);
  const [appointmentCart, setAppointmentCart] = useState<GetAppointmentCartByUid | undefined>(undefined);
  const client = useApolloClient();

  useEffect(() => {
    if (appointmentCartUid) {
      getAppointmentCartByUid(
        client.query,
        undefined,
        appointmentCartUid,
      ).then(cart => {
        if (cart) {
          setAppointmentCart(cart);
        }
      }).finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [appointmentCartUid]);

  return [appointmentCart, isLoading];
};

export default useAppointmentCartCookie;

